import { useEffect, useRef, useState } from "react";

const brands = [
  { name: "SBI Life", file: "sbi-life.jpg" },
  { name: "Star Health Insurance", file: "star-health.jpg" },
  { name: "Tata AIG", file: "tata-aig.jpg" },
  { name: "United India Insurance", file: "united-india.jpg" },
  { name: "Bajaj Life", file: "bajaj-life.jpg" },
  { name: "HDFC ERGO", file: "hdfc-ergo.jpg" },
  { name: "HDFC Life", file: "hdfc-life.jpg" },
  { name: "ICICI Lombard", file: "icici-lombard.jpg" },
  { name: "LIC", file: "lic.jpg" },
  { name: "New India Assurance", file: "new-india-assurance.jpg" },
  { name: "Aditya Birla Capital", file: "aditya-birla-capital.jpg" },
  { name: "Royal Sundaram", file: "royal-sundaram.jpg" },
];

function useItemsPerView() {
  const [perView, setPerView] = useState(3);
  useEffect(() => {
    const compute = () => {
      const w = window.innerWidth;
      if (w < 640) setPerView(2);
      else if (w < 1024) setPerView(3);
      else setPerView(4);
    };
    compute();
    window.addEventListener("resize", compute);
    return () => window.removeEventListener("resize", compute);
  }, []);
  return perView;
}

export default function BrandPartners() {
  const perView = useItemsPerView();
  const totalGroups = Math.ceil(brands.length / perView);
  const [group, setGroup] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    setGroup(0);
  }, [perView]);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setGroup((g) => (g + 1) % totalGroups);
    }, 2800);
    return () => clearInterval(timerRef.current);
  }, [totalGroups]);

  // pad the brand list so every group has exactly `perView` items
  const padded = [...brands];
  while (padded.length % perView !== 0) padded.push(null);

  return (
    <section
      data-testid="brand-partners-section"
      className="pt-10 md:pt-14 pb-10 md:pb-14 border-b border-[#EFEFEA] bg-[#FAFAF8]"
    >
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="mb-12">
          <p className="inline-flex items-center gap-2 text-[11px] tracking-[0.14em] uppercase text-[#C9A227]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#C9A227]" />
            Brand Partners
          </p>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-[42px] leading-[1.05] tracking-tight text-[#0F172A]">
            Trusted by our
            <br />
            <span className="italic">brand partners.</span>
          </h2>
        </div>

        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
            style={{ transform: `translateX(-${group * 100}%)` }}
          >
            {Array.from({ length: totalGroups }).map((_, gi) => (
              <div
                key={gi}
                className="flex shrink-0 w-full"
                style={{ gap: "1.5rem" }}
              >
                {padded.slice(gi * perView, gi * perView + perView).map((brand, i) =>
                  brand ? (
                    <div
                      key={brand.file}
                      className="flex-1 min-w-0"
                    >
                      <div className="h-24 md:h-28 flex items-center justify-center p-5">
                        <img
                          src={`/assets/brands/${brand.file}`}
                          alt={brand.name}
                          className="max-h-full max-w-full object-contain"
                        />
                      </div>
                    </div>
                  ) : (
                    <div key={`empty-${i}`} className="flex-1 min-w-0" />
                  )
                )}
              </div>
            ))}
          </div>
        </div>

        {/* progress dots */}
        <div className="flex items-center justify-center gap-2 mt-7">
          {Array.from({ length: totalGroups }).map((_, gi) => (
            <button
              key={gi}
              aria-label={`Show partner group ${gi + 1}`}
              onClick={() => setGroup(gi)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                gi === group ? "w-6 bg-[#C9A227]" : "w-1.5 bg-[#E2E8F0]"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}